// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Premios_container__FVEtq {
  animation: Premios_init__rOfBQ 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

/*--Header--*/
.Premios_container__FVEtq .Premios_header__IcFIQ {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Premios_container__FVEtq .Premios_header__IcFIQ .Premios_titleContainer__fEUCd {
  animation: Premios_init2__koqdv 0.5s both;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Premios_container__FVEtq .Premios_header__IcFIQ .Premios_titleContainer__fEUCd h4 {
  text-align: center;
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

.Premios_filters__KqWSr {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.Premios_filterButton__S4CGu {
  animation: Premios_init3__gg9J0 0.5s both;
  height: 3rem;
  width: 10rem;
  margin-left: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.Premios_filterButton__S4CGu p {
  text-transform: capitalize;
  margin-left: 5px;
  font-weight: 400;
}

.Premios_container__FVEtq .Premios_selectAgency__nb-FH {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Premios_container__FVEtq .Premios_content__lt620 {
  animation: Premios_init3__gg9J0 0.5s both;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  align-items: center;
  height: 90%;
}

.Premios_container__FVEtq .Premios_content__lt620 .Premios_tabContainer__CqSQl {
  display: flex;
  flex-wrap: wrap;
  /*flex-direction: column;*/
  align-items: flex-end;
  max-height: 47px;
  /*width: 90%;*/
}

.Premios_container__FVEtq .Premios_content__lt620 .Premios_tabContainer__CqSQl .Premios_tabs__fKgJA .MuiTabs-indicator {
  display: none;
}

.Premios_container__FVEtq .Premios_content__lt620 .Premios_tabContainer__CqSQl .Premios_tabs__fKgJA .Premios_tabItem__QHqib {
  border: 1px solid #e9e9e9;
  background: #f7f7f7;
  font-size: 0.7em;
  border-radius: 15px 15px 0 0;
  margin-left: 5px;
  text-transform: capitalize;
}

.Premios_container__FVEtq .Premios_content__lt620 .Premios_tabContainer__CqSQl .Premios_tabs__fKgJA .Premios_selected__-6Gkr {
  transition-delay: 0.2s;
  border-bottom-width: 0;
  background-color: #ffffff;
}

.Premios_container__FVEtq .Premios_content__lt620 .Premios_render__5i\\+3p {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #e9e9e9;
}

.Premios_container__FVEtq .Premios_content__lt620 .Premios_noAgencieSelected__XCpst {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.Premios_container__FVEtq .Premios_content__lt620 .Premios_noAgencieSelected__XCpst h3 {
  font-size: 1.8rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-top: 10%;
}

.Premios_container__FVEtq .Premios_content__lt620 .Premios_noAgencieSelected__XCpst .Premios_redirectBtn__3vo6x {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  width: 20%;
  border-radius: 10px;
  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.298);
}

@media screen and (min-width: 1800px) and (min-height: 800px) {
  .Premios_container__FVEtq {
    margin-top: 5%;
  }
}

@keyframes Premios_init2__koqdv {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes Premios_init3__gg9J0 {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Premios/Premios.module.css"],"names":[],"mappings":"AAAA;EACE,iCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yCAA0B;EAC1B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yCAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yCAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n/*--Header--*/\n.container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  animation: init2 0.5s both;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  text-align: center;\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.filterButton {\n  animation: init3 0.5s both;\n  height: 3rem;\n  width: 10rem;\n  margin-left: 5px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.filterButton p {\n  text-transform: capitalize;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n.container .selectAgency {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .content {\n  animation: init3 0.5s both;\n  display: flex;\n  flex-direction: column;\n  margin-top: 10px;\n  align-items: center;\n  height: 90%;\n}\n\n.container .content .tabContainer {\n  display: flex;\n  flex-wrap: wrap;\n  /*flex-direction: column;*/\n  align-items: flex-end;\n  max-height: 47px;\n  /*width: 90%;*/\n}\n\n.container .content .tabContainer .tabs :global .MuiTabs-indicator {\n  display: none;\n}\n\n.container .content .tabContainer .tabs .tabItem {\n  border: 1px solid #e9e9e9;\n  background: #f7f7f7;\n  font-size: 0.7em;\n  border-radius: 15px 15px 0 0;\n  margin-left: 5px;\n  text-transform: capitalize;\n}\n\n.container .content .tabContainer .tabs .selected {\n  transition-delay: 0.2s;\n  border-bottom-width: 0;\n  background-color: #ffffff;\n}\n\n.container .content .render {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  width: 100%;\n  background-color: #ffffff;\n  border: 1px solid #e9e9e9;\n}\n\n.container .content .noAgencieSelected {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .content .noAgencieSelected h3 {\n  font-size: 1.8rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-top: 10%;\n}\n\n.container .content .noAgencieSelected .redirectBtn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  width: 20%;\n  border-radius: 10px;\n  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.298);\n}\n\n@media screen and (min-width: 1800px) and (min-height: 800px) {\n  .container {\n    margin-top: 5%;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n\n@keyframes init3 {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Premios_container__FVEtq`,
	"init": `Premios_init__rOfBQ`,
	"header": `Premios_header__IcFIQ`,
	"titleContainer": `Premios_titleContainer__fEUCd`,
	"init2": `Premios_init2__koqdv`,
	"filters": `Premios_filters__KqWSr`,
	"filterButton": `Premios_filterButton__S4CGu`,
	"init3": `Premios_init3__gg9J0`,
	"selectAgency": `Premios_selectAgency__nb-FH`,
	"content": `Premios_content__lt620`,
	"tabContainer": `Premios_tabContainer__CqSQl`,
	"tabs": `Premios_tabs__fKgJA`,
	"tabItem": `Premios_tabItem__QHqib`,
	"selected": `Premios_selected__-6Gkr`,
	"render": `Premios_render__5i+3p`,
	"noAgencieSelected": `Premios_noAgencieSelected__XCpst`,
	"redirectBtn": `Premios_redirectBtn__3vo6x`
};
export default ___CSS_LOADER_EXPORT___;
